import { useWindowEvent } from '@fabric-app/hooks/useWindowEvent';
import { useState } from 'react';

const useDroppable = ({ onDrop, maxFiles = Infinity, accept = () => true }) => {
  const [draggingState, setDraggingState] = useState("none");
  const validateDrop = (event) => {
    if (event.dataTransfer.items.length > maxFiles) {
      return false;
    }
    for (let i = 0; i < event.dataTransfer.items.length; i++) {
      if (!accept(event.dataTransfer.items[i])) {
        return false;
      }
    }
    return true;
  };
  useWindowEvent("blur", () => {
    setDraggingState("none");
  });
  return {
    draggingState,
    dragEvents: {
      onDragOver: (event) => {
        event.preventDefault();
        setDraggingState(validateDrop(event) ? "valid" : "invalid");
      },
      onDragLeave: () => {
        setDraggingState("none");
      },
      onDrop: (event) => {
        event.preventDefault();
        if (!validateDrop(event)) {
          return;
        }
        setDraggingState("none");
        onDrop(event);
      }
    }
  };
};

export { useDroppable };
//# sourceMappingURL=useDroppable.js.map
